import { useState, useEffect } from "react";
import { NEWS_ARTICLES, getArticleBySlug } from "./newsData";

const COLORS = {
  navy: "#003366",
  navyDark: "#001f44",
  red: "#cc0000",
  greyPage: "#f0f2f5",
  greyMid: "#c8cdd6",
  greyDark: "#555e6d",
  white: "#ffffff",
  textDark: "#1a2233",
  textMid: "#3d4a5c",
};

const LOGO =
  "https://arcuchicnc.com/wp-content/uploads/2023/07/Untitled-6.png";

const TAG_COLORS = {
  Technology: "#0055aa",
  "Control Systems": "#006644",
  Hydraulics: "#663300",
  "Upgrade Guide": "#5500aa",
  "Energy Efficiency": "#007755",
  Comparison: "#aa5500",
};

function useWindowWidth() {
  const [w, setW] = useState(window.innerWidth);
  useEffect(() => {
    const fn = () => setW(window.innerWidth);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);
  return w;
}

function DetailNavbar() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav
      style={{
        position: "sticky", top: 0, zIndex: 1000,
        background: COLORS.navyDark,
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: isMobile ? "0 20px" : "0 40px", height: 64,
        boxShadow: "0 2px 16px rgba(0,0,0,0.3)",
      }}
    >
      <a href="#/" style={{ display: "flex", alignItems: "center", gap: 12, textDecoration: "none" }}>
        <img src={LOGO} alt="Arcuchi" style={{ height: 36, objectFit: "contain" }} />
      </a>

      {isMobile ? (
        <>
          <button
            onClick={() => setMenuOpen((o) => !o)}
            style={{ background: "none", border: "none", cursor: "pointer", display: "flex", flexDirection: "column", gap: 5, padding: 8 }}
          >
            {[0, 1, 2].map((i) => (
              <span key={i} style={{
                display: "block", width: 24, height: 2, background: "#fff", borderRadius: 2, transition: "0.3s",
                transform:
                  menuOpen && i === 0 ? "rotate(45deg) translate(5px,5px)" :
                  menuOpen && i === 1 ? "scaleX(0)" :
                  menuOpen && i === 2 ? "rotate(-45deg) translate(5px,-5px)" : "none",
              }} />
            ))}
          </button>
          {menuOpen && (
            <div style={{
              position: "absolute", top: 64, left: 0, right: 0,
              background: COLORS.navyDark, borderTop: `2px solid ${COLORS.red}`,
              boxShadow: "0 8px 24px rgba(0,0,0,0.3)", zIndex: 999,
            }}>
              {[
                { label: "Home", href: "#/" },
                { label: "About", href: "#/about" },
                { label: "News", href: "#/news" },
                { label: "Contact", href: "#/contact" },
              ].map(({ label, href }) => (
                <a
                  key={label}
                  href={href}
                  onClick={() => setMenuOpen(false)}
                  style={{
                    display: "block", padding: "14px 24px",
                    fontFamily: "Montserrat,sans-serif", fontSize: 12, fontWeight: 700,
                    color: "rgba(255,255,255,0.65)", textDecoration: "none",
                    textTransform: "uppercase", letterSpacing: "0.1em",
                    borderBottom: "1px solid rgba(255,255,255,0.06)",
                    borderLeft: "3px solid transparent",
                  }}
                >
                  {label}
                </a>
              ))}
            </div>
          )}
        </>
      ) : (
        <div style={{ display: "flex", alignItems: "center", gap: 28 }}>
          {[
            { label: "Home", href: "#/" },
            { label: "About", href: "#/about" },
            { label: "News", href: "#/news" },
            { label: "Contact", href: "#/contact" },
          ].map(({ label, href }) => (
            <a key={label} href={href} style={{
              fontFamily: "Montserrat,sans-serif", fontSize: 11, fontWeight: 700,
              letterSpacing: "0.1em",
              color: label === "News" ? "#fff" : "rgba(255,255,255,0.65)",
              textDecoration: "none", textTransform: "uppercase", paddingBottom: 2,
              borderBottom: label === "News" ? `2px solid ${COLORS.red}` : "2px solid transparent",
            }}>
              {label}
            </a>
          ))}
          <a href="#/contact" style={{
            background: COLORS.red, color: "#fff",
            fontFamily: "Montserrat,sans-serif", fontSize: 11, fontWeight: 700,
            letterSpacing: "0.1em", textTransform: "uppercase",
            padding: "9px 20px", borderRadius: 2, textDecoration: "none",
          }}>
            Get Quote
          </a>
        </div>
      )}
    </nav>
  );
}

function ArticleHero({ article }) {
  const w = useWindowWidth();
  const isMobile = w < 768;
  const tagColor = TAG_COLORS[article.tag] || COLORS.navy;

  return (
    <div style={{ position: "relative", overflow: "hidden", height: isMobile ? 280 : 440 }}>
      <img
        src={article.img}
        alt={article.title}
        style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }}
      />
      <div style={{
        position: "absolute", inset: 0,
        background: "linear-gradient(to top, rgba(0,10,30,0.95) 0%, rgba(0,10,30,0.6) 50%, rgba(0,0,0,0.2) 100%)",
      }} />
      <div style={{
        position: "absolute", inset: 0,
        display: "flex", flexDirection: "column", justifyContent: "flex-end",
        padding: isMobile ? "28px 20px" : "48px 80px",
        maxWidth: 900,
      }}>
        {/* Breadcrumb */}
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
          <a href="#/" style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, color: "rgba(255,255,255,0.5)", textDecoration: "none" }}>Home</a>
          <span style={{ color: "rgba(255,255,255,0.3)", fontSize: 9 }}>›</span>
          <a href="#/news" style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, color: "rgba(255,255,255,0.5)", textDecoration: "none" }}>News</a>
          <span style={{ color: "rgba(255,255,255,0.3)", fontSize: 9 }}>›</span>
          <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, color: "rgba(255,255,255,0.7)" }}>Article</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
          <span style={{
            background: tagColor, color: "#fff",
            fontFamily: "Montserrat,sans-serif", fontSize: 9, fontWeight: 800,
            letterSpacing: "0.15em", textTransform: "uppercase", padding: "5px 12px", borderRadius: 2,
          }}>{article.tag}</span>
          <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, color: "rgba(255,255,255,0.55)", letterSpacing: "0.06em" }}>
            {article.date} · {article.readTime}
          </span>
        </div>
        <h1 style={{
          fontFamily: "Montserrat,sans-serif",
          fontSize: isMobile ? "clamp(18px,5vw,24px)" : "clamp(24px,3vw,38px)",
          fontWeight: 900, color: "#fff", textTransform: "uppercase",
          letterSpacing: "0.03em", lineHeight: 1.25, margin: "0 0 10px",
        }}>{article.title}</h1>
        <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, color: "rgba(255,255,255,0.45)", letterSpacing: "0.06em" }}>
          By {article.author}
        </div>
      </div>
    </div>
  );
}

function ArticleBody({ body }) {
  return (
    <div style={{ maxWidth: 760, margin: "0 auto" }}>
      {body.map((block, i) => {
        if (block.type === "intro") {
          return (
            <p key={i} style={{
              fontFamily: "Georgia,serif", fontSize: 17, color: COLORS.textDark,
              lineHeight: 1.85, fontStyle: "italic", margin: "0 0 32px",
              borderLeft: `3px solid ${COLORS.red}`, paddingLeft: 20,
            }}>
              {block.text}
            </p>
          );
        }
        if (block.type === "heading") {
          return (
            <h2 key={i} style={{
              fontFamily: "Montserrat,sans-serif", fontSize: 18, fontWeight: 800,
              color: COLORS.textDark, textTransform: "uppercase", letterSpacing: "0.04em",
              margin: "40px 0 16px", paddingBottom: 10,
              borderBottom: `2px solid ${COLORS.greyPage}`,
            }}>
              {block.text}
            </h2>
          );
        }
        if (block.type === "paragraph") {
          return (
            <p key={i} style={{
              fontFamily: "Georgia,serif", fontSize: 15.5, color: COLORS.textMid,
              lineHeight: 1.85, margin: "0 0 22px",
            }}>
              {block.text}
            </p>
          );
        }
        if (block.type === "list") {
          return (
            <ul key={i} style={{ margin: "0 0 28px", padding: "0 0 0 4px", listStyle: "none" }}>
              {block.items.map((item, j) => (
                <li key={j} style={{
                  display: "flex", gap: 14, alignItems: "flex-start",
                  fontFamily: "Georgia,serif", fontSize: 15, color: COLORS.textMid,
                  lineHeight: 1.8, marginBottom: 12,
                }}>
                  <span style={{
                    flex: "0 0 6px", height: 6, width: 6, borderRadius: "50%",
                    background: COLORS.red, marginTop: 10,
                  }} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          );
        }
        if (block.type === "quote") {
          return (
            <blockquote key={i} style={{
              background: COLORS.navyDark, borderLeft: `4px solid ${COLORS.red}`,
              margin: "36px 0", padding: "28px 32px", borderRadius: "0 4px 4px 0",
            }}>
              <p style={{
                fontFamily: "Georgia,serif", fontSize: 16, fontStyle: "italic",
                color: "rgba(255,255,255,0.85)", lineHeight: 1.75, margin: "0 0 12px",
              }}>
                "{block.text}"
              </p>
              <cite style={{
                fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700,
                color: COLORS.red, textTransform: "uppercase", letterSpacing: "0.1em",
                fontStyle: "normal",
              }}>
                — {block.attribution}
              </cite>
            </blockquote>
          );
        }
        return null;
      })}
    </div>
  );
}

function RelatedArticles({ current }) {
  const related = NEWS_ARTICLES.filter((a) => a.slug !== current.slug).slice(0, 3);
  const w = useWindowWidth();
  const isMobile = w < 768;

  return (
    <div style={{ background: COLORS.greyPage, padding: isMobile ? "40px 20px" : "60px 40px" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 32 }}>
          <div style={{ width: 28, height: 2, background: COLORS.red }} />
          <h3 style={{
            fontFamily: "Montserrat,sans-serif", fontSize: 11, fontWeight: 700,
            color: COLORS.red, textTransform: "uppercase", letterSpacing: "0.2em", margin: 0,
          }}>
            Related Articles
          </h3>
        </div>
        <div style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr 1fr",
          gap: 20,
        }}>
          {related.map((article) => {
            const tagColor = TAG_COLORS[article.tag] || COLORS.navy;
            return (
              <a
                key={article.slug}
                href={`#/news/${article.slug}`}
                style={{
                  display: "flex", flexDirection: "column",
                  background: "#fff", borderRadius: 4, overflow: "hidden",
                  textDecoration: "none",
                  boxShadow: "0 3px 12px rgba(0,0,0,0.08)",
                  transition: "transform 0.25s, box-shadow 0.25s",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 12px 32px rgba(0,0,0,0.15)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 3px 12px rgba(0,0,0,0.08)"; }}
              >
                <div style={{ position: "relative", height: 160, overflow: "hidden" }}>
                  <img src={article.img} alt={article.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  <span style={{
                    position: "absolute", top: 12, left: 12,
                    background: tagColor, color: "#fff",
                    fontFamily: "Montserrat,sans-serif", fontSize: 8, fontWeight: 800,
                    letterSpacing: "0.14em", textTransform: "uppercase", padding: "3px 9px", borderRadius: 2,
                  }}>{article.tag}</span>
                </div>
                <div style={{ padding: "16px 18px 20px" }}>
                  <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 9, color: COLORS.greyDark, marginBottom: 8 }}>
                    {article.date} · {article.readTime}
                  </div>
                  <div style={{
                    fontFamily: "Montserrat,sans-serif", fontSize: 12, fontWeight: 700,
                    color: COLORS.textDark, textTransform: "uppercase", letterSpacing: "0.02em",
                    lineHeight: 1.4, marginBottom: 10,
                  }}>{article.title}</div>
                  <div style={{
                    display: "inline-flex", alignItems: "center", gap: 5,
                    fontFamily: "Montserrat,sans-serif", fontSize: 9.5, fontWeight: 700,
                    color: COLORS.red, textTransform: "uppercase", letterSpacing: "0.08em",
                  }}>
                    Read More →
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
}

function NewsDetailFooter() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  return (
    <footer style={{ background: COLORS.navyDark, padding: isMobile ? "36px 20px" : "48px 40px" }}>
      <div style={{
        display: "flex", flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "flex-start" : "center",
        justifyContent: "space-between", gap: 20,
        borderBottom: "1px solid rgba(255,255,255,0.08)", paddingBottom: 28, marginBottom: 24,
      }}>
        <img src={LOGO} alt="Arcuchi" style={{ height: 32, objectFit: "contain" }} />
        <div style={{ display: "flex", gap: isMobile ? 16 : 28, flexWrap: "wrap" }}>
          {[
            { label: "Home", href: "#/" },
            { label: "About", href: "#/about" },
            { label: "News", href: "#/news" },
            { label: "Contact", href: "#/contact" },
          ].map(({ label, href }) => (
            <a key={label} href={href} style={{
              fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 600,
              color: "rgba(255,255,255,0.55)", textDecoration: "none", letterSpacing: "0.08em",
              textTransform: "uppercase",
            }}>{label}</a>
          ))}
        </div>
      </div>
      <p style={{
        fontFamily: "Montserrat,sans-serif", fontSize: 10, color: "rgba(255,255,255,0.3)",
        textAlign: "center", margin: 0, letterSpacing: "0.06em",
      }}>
        © 2025 Shenzhen Arcuchi Technology Co., Ltd. All rights reserved.
      </p>
    </footer>
  );
}

export default function NewsDetailPage({ slug }) {
  const w = useWindowWidth();
  const isMobile = w < 768;
  const article = getArticleBySlug(slug);

  useEffect(() => {
    if (article) {
      document.title = `${article.title} — Arcuchi CNC`;
    }
    window.scrollTo(0, 0);
  }, [slug, article]);

  if (!article) {
    return (
      <div style={{ background: COLORS.greyPage, minHeight: "100vh" }}>
        <DetailNavbar />
        <div style={{ maxWidth: 600, margin: "80px auto", textAlign: "center", padding: "0 20px" }}>
          <h1 style={{ fontFamily: "Montserrat,sans-serif", fontSize: 24, color: COLORS.textDark, marginBottom: 16 }}>
            Article Not Found
          </h1>
          <p style={{ fontFamily: "Georgia,serif", fontSize: 15, color: COLORS.greyDark, marginBottom: 28 }}>
            The article you're looking for doesn't exist or may have been moved.
          </p>
          <a href="#/news" style={{
            display: "inline-block", background: COLORS.red, color: "#fff",
            fontFamily: "Montserrat,sans-serif", fontSize: 11, fontWeight: 700,
            letterSpacing: "0.1em", textTransform: "uppercase",
            padding: "12px 28px", borderRadius: 2, textDecoration: "none",
          }}>
            ← Back to News
          </a>
        </div>
        <NewsDetailFooter />
      </div>
    );
  }

  return (
    <div style={{ fontFamily: "Montserrat,sans-serif", background: "#fff", minHeight: "100vh" }}>
      <DetailNavbar />
      <ArticleHero article={article} />

      {/* Article content */}
      <div style={{ background: "#fff", padding: isMobile ? "36px 20px" : "56px 40px" }}>
        {/* Back + Share bar */}
        <div style={{
          maxWidth: 1100, margin: "0 auto 40px",
          display: "flex", justifyContent: "space-between", alignItems: "center",
          flexWrap: "wrap", gap: 12,
        }}>
          <a href="#/news" style={{
            display: "inline-flex", alignItems: "center", gap: 8,
            fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700,
            color: COLORS.greyDark, textDecoration: "none",
            textTransform: "uppercase", letterSpacing: "0.1em",
            border: `1px solid ${COLORS.greyMid}`, padding: "8px 16px", borderRadius: 2,
            transition: "border-color 0.2s, color 0.2s",
          }}
            onMouseEnter={(e) => { e.currentTarget.style.color = COLORS.navy; e.currentTarget.style.borderColor = COLORS.navy; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = COLORS.greyDark; e.currentTarget.style.borderColor = COLORS.greyMid; }}
          >
            ← All Articles
          </a>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: 9.5, color: COLORS.greyDark, letterSpacing: "0.08em", textTransform: "uppercase" }}>
              Share:
            </span>
            {[
              { label: "LinkedIn", color: "#0077b5" },
              { label: "Twitter", color: "#1da1f2" },
              { label: "Email", color: COLORS.navy },
            ].map(({ label, color }) => (
              <span key={label} style={{
                fontFamily: "Montserrat,sans-serif", fontSize: 9, fontWeight: 700,
                color, border: `1px solid ${color}`, padding: "5px 12px",
                borderRadius: 2, cursor: "pointer", letterSpacing: "0.08em",
                textTransform: "uppercase",
              }}>
                {label}
              </span>
            ))}
          </div>
        </div>

        <ArticleBody body={article.body} />

        {/* CTA Banner */}
        <div style={{
          maxWidth: 760, margin: "48px auto 0",
          background: COLORS.navyDark, borderRadius: 4,
          padding: isMobile ? "28px 24px" : "36px 40px",
          display: "flex", flexDirection: isMobile ? "column" : "row",
          alignItems: "center", justifyContent: "space-between", gap: 20,
        }}>
          <div>
            <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 11, fontWeight: 700, color: COLORS.red, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 8 }}>
              Ready to Upgrade?
            </div>
            <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 16, fontWeight: 800, color: "#fff", letterSpacing: "0.02em" }}>
              Talk to an Arcuchi Engineer Today
            </div>
          </div>
          <a href="#/contact" style={{
            display: "inline-block", background: COLORS.red, color: "#fff",
            fontFamily: "Montserrat,sans-serif", fontSize: 11, fontWeight: 700,
            letterSpacing: "0.1em", textTransform: "uppercase",
            padding: "13px 28px", borderRadius: 2, textDecoration: "none",
            whiteSpace: "nowrap",
          }}>
            Contact Us →
          </a>
        </div>
      </div>

      <RelatedArticles current={article} />
      <NewsDetailFooter />
    </div>
  );
}
